import { appConfig } from '../../../config/app-config';
import { formatDiscount, formatPrice } from '../../../shared/utils/format';
import { Money } from '../types/cartTypes';

interface DiscountValue {
  type: 'relative' | 'absolute';
  permyriad?: number;
  money?: Money[];
}

interface DiscountObj {
  value: DiscountValue;
  name?: Record<string, string>;
}

interface PriceProps {
  value: Money;
  discounted?: {
    value?: Money;
    discount?: { obj?: DiscountObj };
  };
}

interface lineItemPriceInfoProps {
  price: PriceProps | null | undefined;
  locale?: string;
}

const lineItemPriceInfo = ({ price, locale = appConfig.defaults.locale }: lineItemPriceInfoProps) => {
  if (!price) {
    return <span>n/a</span>;
  }

  if (price.discounted && price.discounted.discount?.obj) {
    const discountObj = price.discounted.discount.obj;
    const currencyCode =
      price.value?.currencyCode ??
      price.discounted?.value?.currencyCode ??
      'USD';
    const discountName =
      discountObj.name?.[locale ?? ''] ??
      discountObj.name?.[appConfig.defaults.locale] ??
      '';

    return (
      <span>
        <s>{formatPrice(price, locale)}</s> {formatPrice({ value: price.discounted.value as Money }, locale)}
        <br />
        <span className="text-sm">
          <em>{formatDiscount(discountObj, currencyCode)} off</em>
          <br />
          Product Discount Name:
          <br /> {discountName}
        </span>
      </span>
    );
  }

  return <span>{formatPrice(price, locale)}</span>;
};

export default lineItemPriceInfo;
